import { Web3AppProvider } from 'modules/blockChain/providers/web3Provider'
import { WalletConnectorsProvider } from 'modules/wallet/providers/walletConnectorsProvider'
import { WalletAutoConnect } from 'modules/wallet/ui/WalletAutoConnect'
import { ModalProvider } from 'modules/modal/providers/ModalProvider'
import { AssetsStateProvider } from 'modules/pools/context'
import { NFCSStateProvider } from 'modules/nfcs/context/NFCSStateProvider'
import { FirebaseProvider } from 'modules/analytics/firebase'

type Props = {
  children: React.ReactNode
}

export function RootProvidersChained({ children }: Props) {
  return (
    <Web3AppProvider>
      <WalletConnectorsProvider>
        <WalletAutoConnect>
          <FirebaseProvider>
            <NFCSStateProvider>
              <AssetsStateProvider>
                <ModalProvider>{children}</ModalProvider>
              </AssetsStateProvider>
            </NFCSStateProvider>
          </FirebaseProvider>
        </WalletAutoConnect>
      </WalletConnectorsProvider>
    </Web3AppProvider>
  )
}
